import type { ChargeCadence } from "./types";

/**
 * Resolve a ticket's charge cadence, with a fallback to the legacy
 * chargeConfig.flatPer* flags for tickets that predate the column or
 * have not yet been backfilled.
 */
export function deriveChargeCadence(
  ticket:
    | {
        chargeCadence?: ChargeCadence | null;
        chargeConfig?: {
          flatPerOrder?: boolean;
          flatPerSession?: boolean;
          flatPerCourse?: boolean;
        } | null;
      }
    | null
    | undefined,
): ChargeCadence {
  if (!ticket) return "per_ticket_per_session";
  if (ticket.chargeCadence) return ticket.chargeCadence;
  const cfg = ticket.chargeConfig ?? {};
  if (cfg.flatPerOrder === true) return "flat";
  if (cfg.flatPerSession === true) return "per_session";
  if (cfg.flatPerCourse === true) return "per_course";
  return "per_ticket_per_session";
}
